import { visualEntities } from "../entities.js";
import { create } from "../helpers/elements.helper.js";
import { VisualSuperHtml } from "./visual-super.environment.js";

class HtmlViewerEnvironment extends VisualSuperHtml {
  handlers = this.extendParentHandlers({
    htmlString: this.setHtml,
  });

  setProps(eNode) {
    const div = document.createElement("div");

    eNode.element = create(eNode, div);

    super.setProps(eNode);
  }

  setHtml(eNode) {
    eNode.element.innerHTML = eNode.props.htmlString;
  }

  clear(eNode) {
    eNode.element.innerHTML = "";
  }
}

const htmlViewerEnvironment = new HtmlViewerEnvironment("visual:htmlViewer");
visualEntities.set("visual:htmlViewer", htmlViewerEnvironment);
export { HtmlViewerEnvironment as HtmlViewerEnv, htmlViewerEnvironment as htmlViewerEnv };
